// extracted by mini-css-extract-plugin
export default {"erasmusu-logo":"ErasmusuLogo_erasmusu-logo__Gt4Oc"};